<div class="col s12">
  <lms-dynamic-form
    [questions]="questions"
    [title]="'customizations.create'"
    [action]="customization ? 'customizations.edit' : 'customizations.create'"
    [options]="{ hideSubmit: true }"
    (submit)="submit()"
  >
    <ng-content select="[form-actions-before]" form-actions-before></ng-content>
  </lms-dynamic-form>
</div>

<div class="col s12">
  <h3 class="h3">{{ 'customizations.structures.docsTitle' | translate }}</h3>
</div>

<div class="col s12">
  <gl-radiobutton
    [id]="questionRadioBtn.id"
    [value]="questionRadioBtn.value"
    [attr.disabled]="questionRadioBtn.disabled ? true : null"
    [options]="questionRadioBtn.options"
  >
  </gl-radiobutton>
</div>

<div class="col s12 margin-top">
  <gl-button
    color-secondary
    class="margin-right"
    [title]="'customizations.documents.automaticDistribution.title' | translate"
    [text]="'customizations.documents.automaticDistribution.text' | translate"
    (onClick)="automaticDistribution()"
  >
  </gl-button>

  <gl-button
    color-secondary
    (onClick)="undo()"
    class="margin-right"
    [text]="'customizations.documents.undo.text' | translate"
    [title]="'customizations.documents.undo.title' | translate"
  >
  </gl-button>

  <gl-button
    color-primary
    [text]="'actions.save' | translate"
    [disabled]="submitDisabled"
    class="margin-right"
    (onClick)="submit()"
    form-actions-before
    [ngClass]="{ tooltipDisabled: submitDisabled }"
    [title]="submitDisabled ? 'actions.fillForm' : ('actions.save' | translate)"
  >
  </gl-button>
  <gl-button
    color-secondary
    [text]="'actions.previsualize' | translate"
    class="right margin-right-gap"
    (onClick)="openVisualizerPopup()"
    [disabled]="submitDisabled"
  >
  </gl-button>
</div>

<div cdkDropListGroup>
  <div class="col s6 m5">
    <p class="margin-top margin-bottom">{{ 'customizations.structures.descriptionExistingDocs' | translate }}</p>
    <div class="margin-bottom">
      <gl-select
        [id]="questionSelect.id"
        [skeletorValueAccessor]="questionSelect"
        [label]="questionSelect.label | translate"
        [placeholder]="questionSelect.placeholder | translate"
        [options]="questionSelect.options"
        [value]="questionSelect.value"
        [separator]="questionSelect.separator"
      >
      </gl-select>
    </div>

    <div [ngClass]="'panel panel-info'">
      <div class="panel-heading">{{ 'documents.leftColumnTitle' | translate }} :{{ filteredDocuments?.length }}</div>
      <div
        class="panel-body min-height"
        cdkDropList
        #filteredDocumentList="cdkDropList"
        [cdkDropListData]="filteredDocuments"
        [cdkDropListConnectedTo]="[documentSelectedList]"
        (cdkDropListDropped)="onDrop($event)"
      >
        <ul class="list-group">
          <li class="list-group-item" *ngFor="let doc of filteredDocuments; let x = index" cdkDrag>
            <div class="custom-placeholder" *cdkDragPlaceholder></div>
            {{ doc.name }} ({{ doc.numQuestions }} {{ 'customizations.dragAndDrop.questionsText' | translate }})
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="col s6 m7">
    <p class="margin-top margin-bottom">{{ 'customizations.structures.descriptionAssignedDocs' | translate }}</p>
    <div [ngClass]="'panel panel-info'">
      <div
        class="col-sm3"
        *ngFor="let turnContainer of turnContainers; let i = index"
        cdkDropList
        #documentSelectedList="cdkDropList"
        [cdkDropListData]="turnContainers[i]['documents']"
        [cdkDropListConnectedTo]="[filteredDocumentList]"
        (cdkDropListDropped)="onDrop($event, turnContainers[i]['documents'])"
      >
        <div class="panel panel-warning">
          <div class="panel-heading">
            {{ 'customizations.structures.turn' | translate : { turn: turnContainer.turn } }}
          </div>
          <div class="panel-body">
            <ul class="list-group">
              <li class="list-group-item" *ngFor="let doc of turnContainer.documents; let x = index" cdkDrag>
                <div class="custom-placeholder" *cdkDragPlaceholder></div>
                {{ doc.name }} ({{ doc.numQuestions }} {{ 'customizations.dragAndDrop.questionsText' | translate }})
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<gl-button
  color-primary
  [text]="'actions.save' | translate"
  [disabled]="submitDisabled"
  (onClick)="submit()"
  form-actions-before
  [ngClass]="{ tooltipDisabled: submitDisabled }"
  [title]="submitDisabled ? 'actions.fillForm' : ('actions.save' | translate)"
></gl-button>
<gl-button
  color-secondary
  [text]="'actions.previsualize' | translate"
  class="right margin-right-gap"
  (onClick)="openVisualizerPopup()"
  [disabled]="submitDisabled"
></gl-button>

<lms-customization-visualizer-popup></lms-customization-visualizer-popup>
